// Autogenerated by script
import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

export const EasyLanguage: typeof SvgIcon & { activeColor: string } = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <circle cx={12} cy={4.585} r={3.391} />
    <path d="M11.472 13.35v9.455a24.345 24.345 0 0 0-6.357-.859 1.052 1.052 0 0 1-1.026-1.055v-8.837a1.06 1.06 0 0 1 1.044-1.057 13.263 13.263 0 0 1 5.416.828 1.677 1.677 0 0 1 .923 1.525Zm7.395-2.353a13.263 13.263 0 0 0-5.416.828 1.678 1.678 0 0 0-.923 1.525v9.455a24.345 24.345 0 0 1 6.357-.859 1.052 1.052 0 0 0 1.026-1.055v-8.837a1.059 1.059 0 0 0-1.044-1.057Z" />
  </SvgIcon>
);

EasyLanguage.activeColor = 'inherit';
EasyLanguage.muiName = 'EasyLanguage';
